import { useCallback, useMemo } from 'react'
import { useAuth } from 'slices/user/hooks'
import type { PlanAccessBlockCode, PlanFeatureKey, PlanLimitKey } from 'Types/plan'

export function usePlanAccess() {
 const { user } = useAuth()
 const access = user?.plan_access ?? null

 const canOperate = access?.can_operate !== false

 const blockCode: PlanAccessBlockCode | null = useMemo(() => {
 if (!access) return null
 if (!access.is_tenant_active) return 'tenant_suspended'
 if (!access.is_subscription_valid) return 'subscription_expired'
 return null
 }, [access])

 const blockMessage = useMemo(() => {
 if (!access) return null
 if (!access.is_tenant_active) {
 return 'تم إيقاف هذا الحساب مؤقتاً. يرجى التواصل مع الدعم.'
 }
 if (!access.is_subscription_valid) {
 return 'انتهت صلاحية الاشتراك. يرجى تجديد الباقة.'
 }
 return null
 }, [access])

 const hasFeature = useCallback(
 (key: PlanFeatureKey) => {
 if (key === 'intelligence') return true
 if (!access) return true
 return Boolean(access.features?.[key])
 },
 [access],
 )

 const getLimit = useCallback(
 (key: PlanLimitKey): number | null => {
 if (!access) return null
 const value = access.limits?.[key]
 return value === undefined || value === null ? null : value
 },
 [access],
 )

 return {
 access,
 plan: access?.plan ?? null,
 canOperate,
 blockCode,
 blockMessage,
 hasFeature,
 getLimit,
 }
}
